export default "__VITE_ASSET__hQKHFiLz__"